export enum OrderWarningType {
  ORDER = 'ORDER',
  ITEM = 'ITEM',
  SPECIAL = 'SPECIAL',
}
